/**
 * Converts string to the binary data
 * @function
 * @param [stringData] {String}
 * @returns {Uint8Array}
 * @example toBinary('some text')
 */
export const toBinary = stringData => {
    const codeUnits = new Uint16Array(stringData.length);

    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = stringData.charCodeAt(i);
    }

    return String.fromCharCode(...new Uint8Array(codeUnits.buffer));
};

/**
 * Converts binary to the string
 * @function
 * @param [binaryData] {Uint8Array}
 * @returns {String}
 * @example fromBinary(Uint8Array)
 */
export const fromBinary = binaryData => {
    const bytes = new Uint8Array(binaryData.length);

    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binaryData.charCodeAt(i);
    }

    return String.fromCharCode(...new Uint16Array(bytes.buffer));
};
